export default __webpack_public_path__ + "static/media/1856.d673fba6.png";